(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["common-modal"] && !Shopify.designMode) return;
  try {
    (function() {
  var triggers = document.querySelectorAll('[data-modal-target]');

  if (!window.HTMLDialogElement || !triggers.length) return;

  function openModal(dialog) {
    if (!dialog.open) dialog.showModal();
  }

  function closeModal(dialog) {
    if (dialog.open) dialog.close();
  }

  document.addEventListener('click', function(event) {
    var trigger = event.target.closest('[data-modal-target]');
    if (trigger) {
      var id = trigger.getAttribute('data-modal-target');
      var dialog = document.getElementById(id);
      if (dialog && dialog.nodeName === 'DIALOG') openModal(dialog);
      return;
    }

    if (event.target.closest('[data-modal-close]')) {
      var dialogEl = event.target.closest('dialog');
      if (dialogEl) closeModal(dialogEl);
    }
  });

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      document.querySelectorAll('dialog[open]').forEach(function(dialog) {
        closeModal(dialog);
      });
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
